import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { AiApiWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('AI')
export class AINode extends BaseWorkflowNode<AiApiWorkflowNode> {
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return (
      this.node.assignments?.flatMap((assignment) =>
        getColumnReferencesFromString(assignment.value, schemas),
      ) ?? []
    );
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return (
      this.node.assignments?.flatMap((assignment) =>
        getTagReferencesFromString(assignment.value, schemas),
      ) ?? []
    );
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return (
      this.node.assignments?.flatMap((assignment) =>
        getParamReferencesFromString(assignment.value, schemas, connectors),
      ) ?? []
    );
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return (
      this.node.assignments?.flatMap((assignment) =>
        getNamedInputReferencesFromString(assignment.value, schemas),
      ) ?? []
    );
  }
}
